import { render, staticRenderFns } from "./AddOption.vue?vue&type=template&id=4808d8da"
import script from "./AddOption.vue?vue&type=script&lang=js"
export * from "./AddOption.vue?vue&type=script&lang=js"
import style0 from "./AddOption.vue?vue&type=style&index=0&id=4808d8da&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4808d8da')) {
      api.createRecord('4808d8da', component.options)
    } else {
      api.reload('4808d8da', component.options)
    }
    module.hot.accept("./AddOption.vue?vue&type=template&id=4808d8da", function () {
      api.rerender('4808d8da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/price/AddOption.vue"
export default component.exports